/* Scoped enhancement only. Native cart and variant events remain owned by the theme. */
(() => {
 'use strict';
 const normalize = v => String(v).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
 function init(root=document) {
  root.querySelectorAll('[data-dag-index]').forEach(index=>{
   if(index.dataset.bound) return;
   const input=index.querySelector('[data-dag-search]'); if(!input)return;
   const rows=[...index.querySelectorAll('[data-dag-name]')];
   const count=index.querySelector('[data-dag-count]'); const empty=index.querySelector('[data-dag-empty]');
   function update(){let n=0;const q=normalize(input.value);rows.forEach(row=>{row.hidden=!normalize(row.dataset.dagName).includes(q);if(!row.hidden)n++;});if(count)count.textContent=count.dataset.countTemplate.replace('[count]',String(n));if(empty)empty.hidden=n!==0;}
   index.dataset.bound='true';input.addEventListener('input',update);update();
  });
  root.querySelectorAll('[data-dag-filter]').forEach(form=>{
   if(form.dataset.bound)return;form.dataset.bound='true';
   form.addEventListener('submit',()=>form.querySelectorAll('input[type="number"]').forEach(input=>{input.disabled=input.value==='';}));
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
